import { createAction } from '@lingoda/core';

export default createAction('auth/REMOVE_CURRENT_USER');
